/*
 * @Author: your name
 * @Date: 2021-07-29 14:15:07
 * @LastEditTime: 2023-10-19 14:28:34
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\api\goodsApi\skuApi.js
 */
/**
 * goods-sku : 商品SKU
 *
 * 值集头创建  POST /v1/price/item/setting/add-head
 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/sgoo/v1/{organizationId}/goods/sku',
  items: [
    /**
     * 新增
     */
    {
      key: 'addSku',
      url: '',
      method: 'POST',
      loadingMore: 999,
    },
    /**
     * 分页
     */
    { key: 'getSku', url: '/pageCsg', method: 'POST' },
    { key: 'getSkuPage', url: '/pageCsgSku', method: 'POST' },
    { key: 'upSkuPage', url: '/updatePackage', method: 'PUT' },
    { key: 'addSkuPage', url: '/createPackage', method: 'POST' },
    { key: 'getSku2', url: '/getSku', method: 'POST' },
    // 获取商品导入记录 post /v1/{organizationId}/goods/sku/goods-import-record/pageList
    { key: 'getSkuImportRecord', url: '/goods-import-record/pageList', method: 'POST', loadingHide: true },
    /**
     * 推送
     */
    { key: 'pushSku', url: '/sku-push-to-sap', method: 'POST' },
    // 校验barCode接口 POST /v1/{organizationId}/goods/sku/check-bar-code
    { key: 'checkBarCode', url: '/check-bar-code', method: 'POST' },
    { key: 'checkBarCodeNew', url: '/new-check-bar-code', method: 'POST' },
    // 校验skuCode接口 POST /v1/{organizationId}/goods/sku/check-bar-code
    { key: 'checkSkuCode', url: '/check-sku-code', method: 'POST' },
    /**
     * 修改
     */
    {
      key: 'updateSku',
      url: '/update',
      method: 'PUT',
    },
    /**
     * 根据属性创建商品sku列表
     */
    {
      key: 'createSku',
      url: '/createSkuList',
      method: 'POST',
    },

    /**
     * SKU详情
     */
    { key: 'detailSku', url: '/{id}', method: 'GET' },
    /**
     * 根据商品id获取已经生成的sku
     */
    { key: 'getOldSkuListBySpuId', url: '/goods/', method: 'GET' },
    /**
     * 批量 提交 审核
     */
    { key: 'skuBatchSubmitAudit', url: '/batchAudit', method: 'PUT' },
    /**
     * 删除
     */
    {
      key: 'deleteSku',
      url: '',
      method: 'DELETE',
    },

    // 修改商品sku显示状态
    {
      key: 'updateSkuStatus',
      url: '/updateShowFlag',
      method: 'PUT',
    },

    // 编辑商品价格
    {
      key: 'updateSkuPrice',
      url: '/sku-price',
      method: 'PUT',
    },

    // 批量获取套餐明细列表  Array[ skuCode]
    {
      key: 'getMealsGoodsList',
      url: '/meals-goods-list',
      method: 'POST',
    },

    // 导出套餐sku
    {
      key: 'exportPackageSku',
      url: '/sku-sales-kit-import',
      method: 'POST',
    },
    {
      key: 'getSkulist',
      url: '/get-skulist',
      method: 'POST',
    },
    // csg 删除sku POST /v1/{organizationId}/goods/sku/delete-sku ==》 马光浩
    { key: 'delSkulist', url: '/delete-sku', method: 'POST' },
    // csg 判断是否可以编辑套餐sku POST /v1/{organizationId}/goods/sku/delete-sku ==》 马光浩
    { key: 'editSkulist', url: '/check-delete-sku', method: 'POST' },
    // csg 更新sku POST /v1/{organizationId}/goods/sku/delete-sku ==》 马光浩
    { key: 'updateSkulist', url: '/update-package-sku', method: 'POST' },

    // csg 包材侧边栏 => 新增 => 包材名称下拉   post /v1/{organizationId}/goods/sku/getWebSkuList ==》 何雪松
    { key: 'getPackageNameList', url: '/getWebSkuList?innerOrderNo={innerOrderNo}', method: 'POST' },
    
    // csg 包材侧边栏 => 新增 => 包材名称下拉   post /v1/{organizationId}/goods/sku/hide-show ==》 马光浩
    { key: 'goodsControlHideShow', url: '/hide-show', method: 'POST' },
  ],
};

export default {
  ...generate(config),
};
